import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { ScanTrackingStatus } from 'consts/giConsts'
import useRolePermissions from 'hooks/useRolePermissions'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useTreatmentTracking from './useTreatmentTracking'
import TreatmentTrackingTagging from './TreatmentTrackingTagging'
import AIScanAnalysis from './AIScanAnalysis/AIScanAnalysis'
import useGaFlags from 'hooks/useGaFlags'

const TreatmentTrackingPanel = ({ scanId }) => {
  const { t } = useTranslation()
  const { isHiUser } = useRolePermissions()
  const { AIForHI } = useGaFlags()

  const { isDismissed, scanTrackingStatus } = useTreatmentTracking({
    scanId
  })

  return isDismissed ? (
    <div>
      <DazzedParagraph14 strong>{t('dialogs.scanSummary.treatmentTracking.scanWasDismissed')}</DazzedParagraph14>
    </div>
  ) : isHiUser && scanTrackingStatus === ScanTrackingStatus.NotRequired ? (
    <div>
      <DazzedParagraph14 strong>{t('dialogs.scanSummary.treatmentTracking.scanNotRequired')}</DazzedParagraph14>
    </div>
  ) : (
    <div>
      {AIForHI && <AIScanAnalysis scanId={scanId} />}
      <TreatmentTrackingTagging scanId={scanId} />
    </div>
  )
}

export default TreatmentTrackingPanel
